import React from "react";

const ServiceAreaFive = () => {
  return (
    <>
      {/*=================== service area five start ===================*/}
      <div className="service-area bg-gray bg-relative pd-top-120 pd-bottom-120">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="section-title text-center">
                <h6 className="sub-title-sky-blue">踏入未来</h6>
                <h2 className="title">探索数据的无限价值，携手人工智能</h2>
              </div>
            </div>
          </div>
          <div className="row custom-no-gutter">
            <div className="col-lg-4 col-md-6">
              <div className="single-service-inner-3 single-service-inner-3-left">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/7.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">人工智能咨询</h5>
                  <p className="mb-0">
                    改善客户服务，通过智能化解决方案提供个性化的客户体验，增加客户忠诚度。
                  </p>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-left">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/8.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">数据思维</h5>
                  <p className="mb-0">
                    通过数据思维，个人和组织可以更好地理解现实世界，发现趋势和模式，以做出更明智的决策。
                  </p>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-left mb-0">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/9.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">生成式人工智能</h5>
                  <p className="mb-0">
                    生成各种类型的媒体，如图像、音频、文本等，具有广泛的应用，包括图像生成、文本生成、创意内容生成等。
                  </p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 bg-blue-right d-lg-inline-block d-none">
              <div className="service-thumb service-middle-section align-self-end"></div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service-inner-3 single-service-inner-3-right">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/10.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">神经网络</h5>
                  <p className="mb-0">
                    使用人工神经网络和深度学习技术，模拟大脑的工作方式，以实现各种任务，包括图像识别、自然语言处理、数据分析和决策支持等
                  </p>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-right">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/11.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">智慧逻辑</h5>
                  <p className="mb-0">改进自动化流程、增强决策支持或提高效率</p>
                </div>
              </div>
              <div className="single-service-inner-3 single-service-inner-3-right mb-0">
                <div className="thumb">
                  <div className="thumb-inner">
                    <img src="assets/img/service-icon/13.svg" alt="img" />
                  </div>
                </div>
                <div className="details">
                  <h5 className="mb-3">计算机视觉</h5>
                  <p className="mb-0">
                    用电脑代替人眼对目标进行识别、跟踪和测量等机器视觉，并进一步做图像处理，用电脑处理成为更适合人眼观察或传送给仪器检测的图像
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* =================== service area end ===================*/}
    </>
  );
};

export default ServiceAreaFive;
